import React from 'react';
import { useScrollTracking } from '../hooks/useScrollTracking';
import { trackCTAClick, trackCalendlyClick } from '../utils/mixpanel';
export function CTASection() {
  const sectionRef = useScrollTracking('cta');
  const handleStartTrialClick = () => {
    trackCTAClick('Start Free Trial', 'cta_section', 'https://calendly.com/alex-thruline/cad-sync-meeting');
    trackCalendlyClick('Start Free Trial', 'cta_section');
  };
  const handleScheduleDemoClick = () => {
    trackCTAClick('Schedule a Demo', 'cta_section', 'https://calendly.com/alex-thruline/cad-sync-meeting');
    trackCalendlyClick('Schedule a Demo', 'cta_section');
  };
  return <section ref={sectionRef as any} className="py-24 px-6 bg-blue-600" data-id="element-34">
      <div className="max-w-4xl mx-auto text-center" data-id="element-35">
        <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6" data-id="element-36">
          Start saving 40+ hours a month
        </h2>
        <p className="text-xl text-blue-100 mb-8" data-id="element-37">
          Start your free 14-day trial today. No credit card required.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-38">
          <a href="https://calendly.com/alex-thruline/cad-sync-meeting" target="_blank" rel="noopener noreferrer" onClick={handleStartTrialClick} className="px-8 py-4 bg-white text-blue-600 font-semibold rounded-lg hover:bg-slate-50 transition-all hover:scale-[1.02] shadow-xl text-center" data-id="element-39">
            Start Free Trial
          </a>
          <a href="https://calendly.com/alex-thruline/cad-sync-meeting" target="_blank" rel="noopener noreferrer" onClick={handleScheduleDemoClick} className="px-8 py-4 bg-blue-700 text-white font-semibold rounded-lg border-2 border-blue-500 hover:bg-blue-800 transition-all hover:scale-[1.02] text-center" data-id="element-40">
            Schedule a Demo
          </a>
        </div>
        <p className="text-blue-100 text-sm mt-6" data-id="element-41">Cancel anytime</p>
      </div>
    </section>;
}